import type { ApolloCache } from "@apollo/client/cache"
import cloneDeep from "lodash-es/cloneDeep"

import {
  ProjectsDocument,
  ProjectsQuery,
  ProjectsQueryVariables
} from "entities/projects/graphql/queries.generated"

export function readProjects(cache: ApolloCache<object>) {
  return cloneDeep(
    cache.readQuery<ProjectsQuery, ProjectsQueryVariables>({
      query: ProjectsDocument,
      optimistic: true
    })?.projects
  )
}
